import { useEffect, useState } from "react";

/* useState backed by localStorage so visitors can leave any form on the
   site and come back without retyping. Storage failures (private mode,
   storage disabled) quietly fall back to plain in-memory state. */
export default function usePersistedState(key, initialValue = "") {
  const storageKey = `simple-bundles-demo:${key}`;

  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      return stored === null ? initialValue : JSON.parse(stored);
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      /* storage unavailable; keep in-memory state only */
    }
  }, [storageKey, value]);

  return [value, setValue];
}
